import * as XLSX from 'xlsx';
import {Range} from "../model/range";

export function downloadXSL(jsonBook, sheetName, fileName, multiJSONBooKs: Array<any> = []) {
  try {
    if (jsonBook.length) {
      let utils: any = XLSX.utils;
      console.log("utils", utils);
      /* make the worksheet */
      var ws = utils.json_to_sheet(jsonBook);

      /* add to workbook */
      var wb = utils.book_new();
      utils.book_append_sheet(wb, ws, sheetName);
      if (multiJSONBooKs.length) {
        multiJSONBooKs.map((jsonBookObj) => {
          let ws = utils.json_to_sheet(jsonBookObj.jsonBook);
          utils.book_append_sheet(wb, ws, jsonBookObj.name);
        });
      }
      /* generate an XLSX file */
      XLSX.writeFile(wb, fileName + '.csv');
    }

  } catch (e) {
    console.log("e", e);
  }
}

/**
 * returns default range of date range selector using provided offset value
 * @param offset
 * @returns {Range}
 */
export function getDefaultRange(offset?: number) {
  let startDate: Date = new Date();
  if (offset) (startDate.setDate(startDate.getDate() - offset));
  startDate.setHours(0, 0, 0, 0);
  let endDate: Date = new Date();
  if (offset) (endDate.setDate(endDate.getDate() - offset));
  endDate.setHours(23, 59, 59, 0);
  return new Range(startDate, endDate);
}

/**
 * returns manipulated city
 * @param city
 * @returns {any}
 */
export function getCity(city) {
  let final;
  switch (city) {
    case 'mangaluru':
      final = 'mangalore';
      break;
    default:
      final = city;
      break;
  }
  return final;
}

/**
 * returns manipulated agency name
 * @param agency
 * @returns {any}
 */
export function getAgency(agency) {
  switch (agency) {
    case 'bcll':
      return 'BCLL';
    default:
      return agency;
  }
}

/**
 * clones the date object
 * @param range
 * @returns {{startDate: Date, endDate: Date}}
 */
export function cloneRangeObject(range: Range) {
  let startDate = new Date(range.startDate.getTime());
  let endDate = new Date(range.endDate.getTime());
  return {startDate, endDate};
}

/**
 * evaluates graph data group for aggregating data on the basis of provided date range
 * @param range
 * @returns {string}
 */
export function getGroup(range: Range) {
  let group: string;
  if (range.tag === 'TODAY' || (range.tag === 'RANGE' && range.startDate.getDate() == range.endDate.getDate() && range.startDate.getMonth() == range.endDate.getMonth() && range.startDate.getFullYear() == range.endDate.getFullYear())) {
    group = 'hour';
  } else {
    group = 'day';
  }
  return group;
}

/**
 * clones the range object and gets updated range with updated hours
 * @param r
 */
export function getUpdatedRange(r: Range) {
  let range = cloneRangeObject(r);
  if (range && range.startDate.getDate() == range.endDate.getDate() && range.startDate.getDate() != new Date().getDate()) {
    range.startDate.setHours(0, 0, 0, 0);
    range.endDate.setHours(23, 59, 59, 0);
  }
  return range;
}
